<script setup lang="ts">
  import { onBeforeUnmount, onMounted, ref, useTemplateRef } from 'vue'

  const { align = 'start' } = defineProps<{
    align?: 'start' | 'end'
  }>()

  defineSlots<{
    trigger: (props: { open: boolean; toggle: () => void }) => unknown
    default: (props: { close: () => void }) => unknown
  }>()

  const open = ref<boolean>(false)
  const root = useTemplateRef<HTMLElement>('root')

  onMounted(() => document.addEventListener('pointerdown', closeOnOutsideClick))
  onBeforeUnmount(() => document.removeEventListener('pointerdown', closeOnOutsideClick))

  function closeOnOutsideClick(event: PointerEvent) {
    if (event.target instanceof Node && !root.value?.contains(event.target)) {
      close()
    }
  }

  function toggle() {
    open.value = !open.value
  }

  function close() {
    open.value = false
  }
</script>

<template>
  <div ref="root" class="popup-anchor" @keydown.esc="close">
    <slot name="trigger" :open="open" :toggle="toggle" />

    <div v-if="open" class="popup" :class="`align-${align}`">
      <slot :close="close" />
    </div>
  </div>
</template>

<style scoped>
  .popup-anchor {
    position: relative;
  }

  .popup {
    position: absolute;
    top: calc(100% + var(--spacing-xs));
    z-index: 10;
    padding: var(--spacing-s);
    background: var(--colours-grey-1);
    border: 1px solid var(--colours-grey-3);
    border-radius: 1rem;
    box-shadow: 0 1rem 2rem 0 var(--colours-shadow-1);
  }

  .popup.align-start {
    left: 0;
  }

  .popup.align-end {
    right: 0;
  }
</style>
